<template>
    <div class="node" :class="{ 'active' : isActiveNode }">
        <Interaction
            v-for="interaction in node.interactions"
            :interaction="interaction"
            :key="interaction.id"
        />
        <interaction-layer v-if="hasInteractionLayer && showInteractionLayer" :node="node" />
        <div
            class="node_overlay"
            @mouseenter="mouseEnter"
            @mouseleave="mouseLeave"
            @click="clicked"
        >&nbsp;</div>
    </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import { EventBus } from '@lib/EventBus';
import _indexOf from 'lodash/indexOf';
import Interaction from './Interaction.vue';
import InteractionLayer from '../modals/InteractionLayer.vue';

export default {
    name: 'Node',
    props: {
        node: {
            type: Object,
            required: true
        },
        activeNode: { type: Number, required: true }
    },
    components: {
        Interaction,
        InteractionLayer
    },
    computed: {
        ...mapGetters(['nodes', 'playing']),
        isActiveNode() {
            return this.activeNode == this.node.id;
        },
        hasInteractionLayer() {
            return (
                this.node.interaction_layer_id &&
                this.node.enable_interaction_layer
            );
        }
    },
    data() {
        return {
            showInteractionLayer: false
        };
    },
    mounted() {
        EventBus.$on('nodeEnded', nodeId => {
            if (nodeId === this.node.id) {
                this.showInteractionLayer = true;
            }
        });
    },
    methods: {
        clicked() {
            EventBus.$emit('mouseClickNode');
        },
        mouseEnter() {
            EventBus.$emit('mouseEnterNode');
        },
        mouseLeave() {
            EventBus.$emit('mouseLeaveNode');
        },
    },
    watch: {
        isActiveNode(active) {
            // hide IL completely , this resets it on Node change
            if (!active) this.showInteractionLayer = false;
        },
        playing(playing) {
            // if the global playing state changes WHILE showing the IL
            // then hide it until "video end" makes it show up again .
            // ⚡️ We needed this because of the replaying same node or same video on different nodes problem
            // that can be triggered from the IL as well 
            if(playing && this.showInteractionLayer ) this.showInteractionLayer = false;
        }
    }
};
</script>
<style>
.node {
    position: absolute;
    z-index: -1;
    opacity: 0;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.2s ease opacity;
}
.active {
    opacity: 1;
    z-index: 5;
}
.node_overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 4;
}
.interactions {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: 0.2s ease all;
}
</style>
